import React from "react";
import { Helmet } from "react-helmet-async";
import { useLang } from "../i18n/LanguageContext";

const titles = {
  az: "BE1 — Gələcəyin rəqəmsal layihələri | Software Studio",
  en: "BE1 — Build the Digital Future | Software Studio",
  ru: "BE1 — Цифровое будущее | Software Studio",
};

const descriptions = {
  az: "BE1 — web tətbiqlər, mobil tətbiqlər, startup MVP-lər, dashboard-lar və xüsusi proqram həlləri yaradan futuristik software studio.",
  en: "BE1 — futuristic software studio building web apps, mobile apps, startup MVPs, dashboards and custom software solutions.",
  ru: "BE1 — футуристическая software-студия: веб-приложения, мобильные приложения, MVP стартапов, дашборды и кастомное ПО.",
};

const SEO = () => {
  const { lang } = useLang();
  return (
    <Helmet>
      <html lang={lang} />
      <title>{titles[lang]}</title>
      <meta name="description" content={descriptions[lang]} />
      <meta property="og:title" content={titles[lang]} />
      <meta property="og:description" content={descriptions[lang]} />
      <meta name="twitter:title" content={titles[lang]} />
      <meta name="twitter:description" content={descriptions[lang]} />
    </Helmet>
  );
};

export default SEO;
